import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";

export const FeaturedProducts = () => {
    const [products, setProducts] = useState([]);

    useEffect(() => {
        api.get("/products").then((res) => {
            setProducts(res.data.filter((p) => p.featured).slice(0, 4));
        }).catch(() => {});
    }, []);

    if (products.length === 0) return null;

    return (
        <section data-testid="featured-section" className="border-b border-line">
            <div className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32">
                <div className="mb-14 flex flex-wrap items-end justify-between gap-6">
                    <div>
                        <p className="font-mono text-xs uppercase tracking-[0.25em] text-clay">The Edit</p>
                        <h2 className="mt-4 font-serif text-3xl font-light tracking-tight text-gold md:text-4xl">
                            This week's <span className="italic text-espresso">favourites</span>
                        </h2>
                    </div>
                    <Link
                        to="/shop"
                        data-testid="featured-view-all-link"
                        className="group flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] transition-colors hover:text-gold"
                    >
                        View all
                        <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
                    </Link>
                </div>
                <div className="grid grid-cols-1 gap-x-8 gap-y-14 sm:grid-cols-2 lg:grid-cols-12">
                    {products.map((p, i) => (
                        <motion.div
                            key={p.id}
                            className={
                                i === 0 ? "lg:col-span-7" : i === 1 ? "lg:col-span-5 lg:mt-20" : i === 2 ? "lg:col-span-5 lg:-mt-10" : "lg:col-span-7 lg:mt-10"
                            }
                        >
                            <ProductCard product={p} index={i} />
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
